var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83329 2.50016H2.33329V5.00016H0.666626V0.833496H4.83329V2.50016ZM17.3333 5.00016V0.833496H13.1666V2.50016H15.6666V5.00016H17.3333ZM4.83329 17.5002H2.33329V15.0002H0.666626V19.1668H4.83329V17.5002ZM15.6666 15.0002V17.5002H13.1666V19.1668H17.3333V15.0002H15.6666ZM13.1666 5.00016H4.83329V15.0002H13.1666V5.00016ZM14.8333 15.0002C14.8333 15.9168 14.0833 16.6668 13.1666 16.6668H4.83329C3.91663 16.6668 3.16663 15.9168 3.16663 15.0002V5.00016C3.16663 4.0835 3.91663 3.3335 4.83329 3.3335H13.1666C14.0833 3.3335 14.8333 4.0835 14.8333 5.00016V15.0002ZM11.5 6.66683H6.49996V8.3335H11.5V6.66683ZM11.5 9.16683H6.49996V10.8335H11.5V9.16683ZM11.5 11.6668H6.49996V13.3335H11.5V11.6668Z",
    fill: "#FFAE13"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsIcon);
export default __webpack_public_path__ + "static/media/creditsIcon.cf903692bfe3b01f56c7bf99e1fe55a0.svg";
export { ForwardRef as ReactComponent };